var exports = {
  "kL": "x43aef4ae--16e0b0--container",
  "Lp": "x43aef4ae--16e0b0--image-wrapper-inner",
  "$0": "x43aef4ae--16e0b0--title-wrapper",
  "Qs": "x43aef4ae--16e0b0--content",
  "kZ": "x43aef4ae--16e0b0--image-wrapper",
  "Jq": "x43aef4ae--16e0b0--promo-label-wrapper",
  "rP": "x43aef4ae--16e0b0--transports-wrapper",
  "G6": "x43aef4ae--16e0b0--rooms-info-wrapper",
};

module.exports = exports;
